import { createAsyncStoragePersister } from "@tanstack/query-async-storage-persister";
import { keepPreviousData, QueryClient } from "@tanstack/react-query";
import { guardedLocalStorage } from "src/utils/persistentStorage";

const STALE_TIME = 60000; // 1 minute

const CACHE_TIME = 1000 * 60 * 60; // 1 hour

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: true,
      retry: false,
      gcTime: CACHE_TIME,
      staleTime: STALE_TIME,
      placeholderData: keepPreviousData,
    },
  },
});

export const QUERY_CACHE_KEY = "REACT_QUERY_OFFLINE_CACHE";

export const persister = createAsyncStoragePersister({
  key: QUERY_CACHE_KEY,
  storage: guardedLocalStorage,
});
